module.exports = __webpack_public_path__ + "media/bootstrap-icons/toggles-f01a53c4.svg";